/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';
import { inject as service } from '@ember/service';
import { use } from 'ember-resources/util/function-resource';
import { AsyncData } from 'embercom/resources/utils/async-data';

export default class FreshdeskTicketsConfiguration extends Model {
  @service declare store: any;
  @service declare appService: { app: { currentAdmin: { id: string }; id: string } };

  @attr('number') declare finFreshdeskUserId: number | undefined;
  @attr('number') declare workflowRulesetId: number;

  @use ruleset = AsyncData<$TSFixMe>(async () => {
    let ruleset = await this.store.peekRecord('matching-system/ruleset', this.workflowRulesetId);

    if (!ruleset) {
      ruleset = await this.store.findRecord('matching-system/ruleset', this.workflowRulesetId);
    }

    let customBot = ruleset.rulesetLinks.firstObject.object;
    customBot.visualBuilderObject.editorConfig = customBot.config.editorConfig;
    return ruleset;
  });
}
